AccountManager = xClass("AccountManager")
let AccountRecoveryTipPanel = require("clover/panel/account/AccountRecoveryTipPanel")
let AccountDelTipPanel = require("clover/panel/account/AccountDelTipPanel")
let AccountProposePanel = require("clover/panel/account/AccountProposePanel")
let AccountDelTipAgainPanel = require("clover/panel/account/AccountDelTipAgainPanel")
let AccountRealDelPanel = require("clover/panel/account/AccountRealDelPanel")
let AccountStopUseTipPanel = require("clover/panel/account/AccountStopUseTipPanel")
let AccountAbnormalTipPanel = require("clover/panel/account/AccountAbnormalTipPanel")



let instance = null
AccountManager.getInstance = function () {
    let self = this
    if (instance) {
        return instance
    }
    instance = AccountManager.create()
    instance.init()
    return instance
}
AccountManager.prototype.init = function () {
    let self = this

}

AccountManager.prototype.isOpen = function () {
    return this.platformIsOpen()
}

AccountManager.prototype.platformIsOpen = function () {
    let self = this
    let delete_switch = MetaManager.getDeleteAccountConfig().delete_switch || ""
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    cc.log("[Account]", "platformIsOpen pf", pf)


    let platform_info = delete_switch;
    let platform_arr = platform_info.split(',');
    if (!self.platformConfig) {
        self.platformConfig = {};
        for (let i = 0; i < platform_arr.length; i++) {
            let conf = platform_arr[i];
            let conf_arr = conf.split(':');
            self.platformConfig[conf_arr[0]] = conf_arr[1];
        }
    }
    let flag = self.platformConfig[pf];
    if (flag == 1) {
        return true;
    } else {
        if (pf == "he"){
            cc.log("[Account]", "platformIsOpen 测试渠道 he  ")
            return true;
        }
        cc.log("[Account]", "platformIsOpen 渠道未开启  ", pf)
        return false;
    }
}

// 删除账号请求
AccountManager.prototype.delAccount = function (onSuccess,onFail) {
    let onSuccessCb = (evt) => {
        cc.log("[Account]", "AccountManager delAccount onSuccessCb evt", evt);
        if (onSuccess)onSuccess(evt.data);
    }
    let onFailCb = (evt) => {
        cc.log("[Account]", "AccountManager delAccount onFailCb evt", evt);
        if (evt && evt.data){
            Toast.make(getText("error.tip."+evt.data.toString()));
        }
        if (onFail)onFail(evt);
    }
    var http = DeleteAccountHttp.new();
    http.addEventListener(Events.kComplete, onSuccessCb);
    http.addEventListener(Events.kError, onFailCb);
    http.addEventListener(Events.kCancel, onFailCb);
    http.load();
}



// 删除提示界面1
AccountManager.prototype.showDelTipPanel = function (cb) {
    if (this.lock) {
        return
    }
    this.lock = true

    AccountDelTipPanel.preloadResPromise(false).then((data)=>{
        // cc.log("[Seaside]", "SeasideStarManager showSeasideStarPanel data",data); 
        this.lock = false
        let panel = AccountDelTipPanel.create()
        panel.popup(true)
        if (cb) cb()
    })
    .catch((err)=>{
        this.lock = false
        console.error("AccountDelTipPanel.preloadResPromise failed.", err)
        if (cb) cb()
    });
}
// 建议界面
AccountManager.prototype.showProposePanel = function (cb) {
    if (this.lock) {
        return
    }
    this.lock = true

    AccountProposePanel.preloadResPromise(false).then((data)=>{
        // cc.log("[Seaside]", "SeasideStarManager showSeasideStarPanel data",data); 
        this.lock = false
        let panel = AccountProposePanel.create()
        panel.popup(true)
        if (cb) cb()
    })
    .catch((err)=>{
        this.lock = false
        console.error("AccountProposePanel.preloadResPromise failed.", err)
        if (cb) cb()
    });
}

// 删除提示界面 2
AccountManager.prototype.showDelTipAgainPanel = function (cb) {
    if (this.lock) {
        return
    }
    this.lock = true

    AccountDelTipAgainPanel.preloadResPromise(false).then((data)=>{
        // cc.log("[Seaside]", "SeasideStarManager showSeasideStarPanel data",data); 
        this.lock = false
        let panel = AccountDelTipAgainPanel.create()
        panel.popup(true)
        if (cb) cb()
    })
    .catch((err)=>{
        this.lock = false
        console.error("AccountDelTipAgainPanel.preloadResPromise failed.", err)
        if (cb) cb()
    });
}
// 真正删除账号界面
AccountManager.prototype.showDelRealPanel = function (cb) {
    if (this.lock) {
        return
    }
    this.lock = true
    AccountRealDelPanel.preloadResPromise(false).then((data)=>{
        // cc.log("[Seaside]", "SeasideStarManager showSeasideStarPanel data",data); 
        this.lock = false
        let panel = AccountRealDelPanel.create()
        panel.popup(true)
        if (cb) cb()
    })
    .catch((err)=>{
        this.lock = false
        console.error("AccountRealDelPanel.preloadResPromise failed.", err)
        if (cb) cb()
    });
}
// 账号停用提示界面
AccountManager.prototype.showStopUsePanel = function (cb) {
    if (this.lock) {
        return
    }
    this.lock = true
    AccountStopUseTipPanel.preloadResPromise(false).then((data)=>{
        // cc.log("[Seaside]", "SeasideStarManager showSeasideStarPanel data",data); 
        this.lock = false
        let panel = AccountStopUseTipPanel.create()
        panel.popup(true)
        if (cb) cb()
    })
    .catch((err)=>{
        this.lock = false
        console.error("AccountStopUseTipPanel.preloadResPromise failed.", err)
        if (cb) cb()
    });
}

AccountManager.prototype.showRecoveryTipPanel = function (data) {
    // if (this.lock) {
    //     return
    // }
    // this.lock = true

    // AccountRecoveryTipPanel.preloadResPromise(false).then(()=>{
    //     this.lock = false
    //     let panel = AccountRecoveryTipPanel.create(data)
    //     panel.popup(true)
    //     if (cb) cb()
    // })
    // .catch((err)=>{
    //     this.lock = false
    //     console.error("AccountRecoveryTipPanel.preloadResPromise failed.", err)
    //     if (cb) cb()
    // });

    let onResLoad = () => {
        let panel = AccountRecoveryTipPanel.create(data)
        panel.popup(true)
    }
    let onFail = () => {
    }

    AccountRecoveryTipPanel.preloadRes(onResLoad, onFail);
}
AccountManager.prototype.showAbnormalTipPanel = function (data) {
    let onResLoad = () => {
        let panel = AccountAbnormalTipPanel.create(data)
        panel.popup(true)
    }
    let onFail = () => {
    }

    AccountAbnormalTipPanel.preloadRes(onResLoad, onFail);
}
//dc-------------------------------------------------------------------------

AccountManager.prototype.createDCSession = function (uid) {
    let uid_new = uid || UserManager.getInstance().uid
    this.dcSession = `${uid_new}_${Localhost.timeInSec()}`
    return this.dcSession
}

AccountManager.prototype.getDCSession = function () {
    return this.dcSession || this.createDCSession()
}
// 点击账号删除
AccountManager.prototype.dcSettingClick = function () {
    this.createDCSession()
    DCAssist.dc4User101("account_delete","setting_click",{session:this.getDCSession()})
}
// 删除界面曝光
AccountManager.prototype.dcDelTipPanelOpen = function () {
    DCAssist.dc4User101("account_delete","reminder_show",{session:this.getDCSession()})
}
// 删除界面 继续删除
AccountManager.prototype.dcDelTipPanelClick = function () {
    DCAssist.dc4User101("account_delete","reminder_click",{session:this.getDCSession()})
}

// 意见反馈界面曝光
AccountManager.prototype.dcProposePanelOpen = function () {
    DCAssist.dc4User101("account_delete","feedback_show",{session:this.getDCSession()})
}
// 意见反馈界面 点击
AccountManager.prototype.dcProposePanelClick = function (t) {
    let param = {}
    param.session = this.getDCSession()
    param.type = t
    DCAssist.dc4User101("account_delete","feedback_click",param)
}

// 二次询问界面曝光
AccountManager.prototype.dcDelTipAgainPanelOpen = function () {
    DCAssist.dc4User101("account_delete","confirm_show",{session:this.getDCSession()})
}
// 二次询问界面 点击
AccountManager.prototype.dcDelTipAgainPanelClick = function (t) {
    let param = {}
    param.session = this.getDCSession()
    param.type = t
    DCAssist.dc4User101("account_delete","confirm_click",param)
}

// 确认删除界面曝光
AccountManager.prototype.dcRealDelPanelOpen = function () {
    DCAssist.dc4User101("account_delete","final_show",{session:this.getDCSession()})
}
// 确认删除界面 继续删除
AccountManager.prototype.dcRealDelPanelClick = function () {
    DCAssist.dc4User101("account_delete","final_click",{session:this.getDCSession()})
}


// 账号停用界面曝光
AccountManager.prototype.dcStopUserTipPanelOpen = function () {
    DCAssist.dc4User101("account_delete","delete_note",{session:this.getDCSession()})
}

// 账号恢复界面曝光
AccountManager.prototype.dcRecoveryTipPanelOpen = function (uid) {
    this.createDCSession(uid)
    DCAssist.dc4User101("account_delete","recovery_show",{session:this.getDCSession()})
}
// 账号恢复界面 点击
AccountManager.prototype.dcRecoveryTipPanelClick = function () {
    DCAssist.dc4User101("account_delete","recovery_click",{session:this.getDCSession()})
}


